import { runDemo } from "../shared/demoRunner";
import { createSpaceDeKScene } from "./scene";

runDemo({ createScene: createSpaceDeKScene });
